export default __webpack_public_path__ + "static/media/speaker1.41b358ce.jpg";